import { type JSX, Show } from 'solid-js';
import { issueLabel } from '../lib/issues';
import { UNSET } from '../lib/unset';
import { StatusPill, type StatusTone } from './StatusPill';

// One issue's handoff state, wherever it's shown (list row + detail drawer).
// Its own file so the tone map has ONE definition — a status that reads
// `danger` in the table and `neutral` in the drawer would be two truths.
// Absent = the step never happened; it stays a quiet placeholder, not a pill.

const HANDOFF_TONE: Record<string, StatusTone> = {
  pending: 'warning',
  accepted: 'success',
  declined: 'danger',
};

export function IssueHandoffPill(props: { status: string | null }): JSX.Element {
  return (
    <Show when={props.status} fallback={<span class="repo-issues__none">{UNSET}</span>}>
      {(status) => (
        <StatusPill tone={HANDOFF_TONE[status()] ?? 'neutral'}>
          {issueLabel('issues_handoff', status())}
        </StatusPill>
      )}
    </Show>
  );
}
